import { useNavigate } from "react-router-dom";
import { Box, Card, CardActionArea, CardContent, CardMedia, Typography } from "@mui/material";
import { vereadoresInfo } from "../vereadorDetalhes";

const TodosVereadores = () => {
  const navigate = useNavigate();

  const handleCardClick = (vereadorId) => {
    navigate(`/vereadores/${vereadorId}`);
  };

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
        gap: 4,
        padding: 4,
      }}
    >
      {Object.entries(vereadoresInfo).map(([id, vereador]) => (
        <Card key={id} sx={{ maxWidth: 200 }} onClick={() => handleCardClick(id)}>
          <CardActionArea>
            <CardMedia
              component="img"
              height="140"
              image={vereador.imagem}
              alt={vereador.nome}
              sx={{ objectFit: "cover" }}
            />
            <CardContent>
              <Typography variant="h6" component="div" sx={{ fontWeight: "bold", textAlign: "center" }}>
                {vereador.nome}
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      ))}
    </Box>
  );
};

export default TodosVereadores;